import { formatMoney } from './theme.js';

function formatMoneySafe(cents, format) {
  const finalFormat = format || window.themeVariables?.settings?.moneyFormat;
 
  if (!finalFormat) {
    return `$${(cents / 100).toFixed(2)}`;
  }
 
  return formatMoney(cents, finalFormat);
}

function updateCardPrice(productCard) {
  const productDataEl = productCard.querySelector(".product-data");
  if (!productDataEl) {
    return;
  }

  const productData = JSON.parse(productDataEl.textContent);

  const priceContainer = productCard.querySelector(".card-price");
  if (!priceContainer) {
    return;
  }

  const moneyFormat = priceContainer.dataset.moneyFormat;
  const discountMode = priceContainer.dataset.discountMode;

  const checkedInput = productCard.querySelector('fieldset input[type="radio"]:checked');

  let selectedVariant;

  if (checkedInput) {
    const selectedColor = checkedInput.value;
    selectedVariant = productData.variants.find(variant =>
      variant.option1 === selectedColor
    );
  }

  if (!selectedVariant) {
    selectedVariant = productData.variants[0];
  }

  if (!selectedVariant) {
    return;
  }

  const formattedPrice = formatMoneySafe(selectedVariant.price, moneyFormat);

  let html = "";

  if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
    const formattedCompare = formatMoneySafe(selectedVariant.compare_at_price, moneyFormat);

    let savingsText = "";

    if (discountMode === "percentage") {
      const percentage = Math.round(
        (selectedVariant.compare_at_price - selectedVariant.price) * 100 / selectedVariant.compare_at_price
      );
      savingsText = `-${percentage}%`;
    } else {
      const moneySaved = formatMoneySafe(
        selectedVariant.compare_at_price - selectedVariant.price,
        moneyFormat
      );
      savingsText = `-${moneySaved}`;
    }

    html = `
      <sale-price class="price price--sale">${formattedPrice}</sale-price>
      <compare-at-price class="text-subdued line-through">${formattedCompare}</compare-at-price>
      <on-sale-badge class="badge badge--on-sale">${savingsText}</on-sale-badge>
    `;
  } else {
    html = `<sale-price class="price">${formattedPrice}</sale-price>`;
  }

  priceContainer.innerHTML = html;
}

function initNewCards(root = document) {
  root.querySelectorAll("product-card, .card, .product-card")
    .forEach(card => {
      if (card.dataset.priceInitialized) return; // evita re-procesar
      card.dataset.priceInitialized = "true";
      updateCardPrice(card);
    });
}

function handleVariantChange(event) {
  const target = event.target;

  if (target.matches('input[type="radio"], select[name="id"]')) {
    const productCard = target.closest("product-card, .card, .product-card");
    if (!productCard) {
      return;
    }
    updateCardPrice(productCard);
  }
}

document.addEventListener("change", handleVariantChange);
document.addEventListener("click", handleVariantChange);

document.addEventListener("DOMContentLoaded", () => initNewCards());

document.addEventListener("shopify:section:load", () => initNewCards());

const observer = new MutationObserver(mutations => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType !== Node.ELEMENT_NODE) continue;

      // Si el nodo mismo es una card
      if (node.matches("product-card, .card, .product-card")) {
        if (!node.dataset.priceInitialized) {
          node.dataset.priceInitialized = "true";
          updateCardPrice(node);
        }
      }

      // Si el nodo contiene cards adentro
      initNewCards(node);
    }
  }
});

observer.observe(document.body, { childList: true, subtree: true });